/**
 * Whether a Shopware write is in flight anywhere in the app, so the UI can block
 * on it. The counter is driven from `plugins/shopwareWriteState.ts`, which decides
 * what counts as a write and guarantees the decrement.
 *
 * Shared through `useState` rather than a module-level ref so the count is per
 * request on the server.
 */
export const useShopwareWriteState = () => {
    const pendingShopwareWrites = useState('shopware-writes:pending', () => 0);

    const isWritingToShopware = computed(() => pendingShopwareWrites.value > 0);

    const beginShopwareWrite = () => {
        pendingShopwareWrites.value += 1;
    };

    const endShopwareWrite = () => {
        pendingShopwareWrites.value = Math.max(0, pendingShopwareWrites.value - 1);
    };

    return { isWritingToShopware, beginShopwareWrite, endShopwareWrite };
};
